import DirectApi from '../../../directApi';
import {EconomicProduct, ExportInvoiceParams} from './ExportInvoiceModal.type';
import Util from '../../../forecast-app/shared/util/util';
import CreateEconomicInvoiceMutation from '../../../mutations/create_economic_invoice_mutation';
import {BUTTON_STYLE, BUTTON_COLOR} from '../../../constants';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import {showModal, MODAL_TYPE} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {IntlShape} from 'react-intl';

const getEconomicProducts = async (): Promise<EconomicProduct[]> => {
	return DirectApi.Fetch(`economic/products`).then(json =>
		json.list.map(item => ({
			value: item.id,
			label: item.name,
			description: item.description,
			unitPrice: item.unitPrice,
			taxable: item.taxable,
		}))
	);
};

export const fetchEconomicProducts = async (setProducts: (products: EconomicProduct[]) => void): Promise<void> => {
	const products = await getEconomicProducts();
	setProducts(products);
};

const onExportInvoiceSuccess = (result, intl: IntlShape, onSuccess: () => void): void => {
	const {formatMessage} = intl;

	onSuccess();

	const {createEconomicInvoice} = result || {};
	if (createEconomicInvoice) {
		const {success, errorMessage} = createEconomicInvoice;

		if (success) {
			createToast({duration: 5000, message: formatMessage({id: 'integrations.economic.invoice_created'})});
		} else {
			showModal({
				type: MODAL_TYPE.WARNING,
				warningMessageId: 'invoicing.not_exported',
				warningInformation: [errorMessage || 'The invoice could not be exported.'],
				buttons: [
					{
						text: formatMessage({id: 'common.ok'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
				],
			});
		}
	}
};

export const exportInvoiceToEconomics = ({
	invoice,
	billTo,
	invoiceRows,
	intl,
	onSuccess,
	onError,
}: ExportInvoiceParams): void => {
	const entryMap = invoiceRows.map(row => ({entryId: row.id, productId: row.economicProduct}));

	const input = {
		invoiceId: invoice.id,
		billToId: billTo.id,
		economicClientId: billTo?.externalId,
		entryMap,
	};

	Util.CommitMutation(
		CreateEconomicInvoiceMutation,
		input,
		result => onExportInvoiceSuccess(result, intl, onSuccess),
		true,
		null,
		onError
	);
};
